import React from 'react';

import { AgentContextPageLoader } from '@confluence/space-settings/entry-points/AgentContextPageLoader.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceSettingsAgentContextRoute = ({ params: { spaceKey } }) => {
	const { isAdminHubAIEnabled, isAIEarlyAccessEnabled } = useSessionData();

	if (
		!isAdminHubAIEnabled ||
		!isAIEarlyAccessEnabled ||
		!expValEquals('cc_space_agents_md_context', 'isEnabled', true)
	) {
		return <NotFound />;
	}

	return (
		<SpaceBase>
			<AgentContextPageLoader spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceSettingsAgentContextRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }) => ({
	Screen: {
		screenEvent: { name: 'agenticSpaceInstructions' },
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
	},
});
